/**
 * The gate (spec 9.5): the last card's image blurred and dimmed as backdrop, «Bereit?» at
 * 44 px, one line of context, the yellow pill, and the note that going back is over. Confirming
 * is awaited — the server has to agree before the cards disappear (build spec 4.3).
 */

import type { Chapter } from "../../shared/api-types.js";
import { Button } from "../../shared/primitives/Button.js";
import { GoalRing, TopicLabel } from "./CardChrome.js";

export function GateScreen({
  chapter,
  categoryLabel,
  today,
  dayGoal,
  questionCount,
  pending,
  error,
  onConfirm,
}: {
  chapter: Chapter;
  categoryLabel: string;
  today: number;
  dayGoal: number;
  questionCount: number;
  pending: boolean;
  error: string | null;
  onConfirm: () => void;
}) {
  const lastCard = chapter.cards[chapter.cards.length - 1];

  return (
    <section className="feed-screen grid place-items-center p-10 text-center">
      {lastCard && (
        <img
          src={lastCard.image.url}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full scale-120 object-cover blur-[30px] brightness-[.35]"
        />
      )}
      <TopicLabel category={categoryLabel} title={chapter.topic.title} />
      <GoalRing today={today} dayGoal={dayGoal} />

      <div className="relative z-2">
        <h2 className="m-0 mb-2 text-[44px] font-black text-white">Bereit?</h2>
        <p className="m-0 mb-7 text-[16px] text-white opacity-80">
          {chapter.cards.length} Karten gelesen. Jetzt kommen {questionCount} Fragen zu «
          {chapter.topic.title}».
        </p>
        <Button
          onClick={onConfirm}
          disabled={pending}
          className="rounded-full bg-[var(--color-accent)] px-11 py-[18px] text-[20px] font-extrabold text-black disabled:opacity-70"
        >
          {pending ? "Einen Moment…" : "Los geht's"}
        </Button>
        <small className="mt-[18px] block text-[13px] text-white opacity-55">
          Zurückblättern geht danach nicht mehr.
        </small>
        {error && (
          <p className="mt-3 mb-0 text-[14px] font-bold text-[var(--color-bad)]">{error}</p>
        )}
      </div>
    </section>
  );
}
